export const contactsData = {
    phone: '+33777735620',
    github: 'https://github.com/jean-joooo',
    linkedIn: 'https://www.linkedin.com/in/jeanjosephagostini/',
    devUsername: "jean-joooo",
}
